import { render } from "./forgetPassword.vue?vue&type=template&id=f7245a86&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=f7245a86&scoped=true&lang=css"

import exportComponent from "F:\\N\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7245a86"]])

export default __exports__